var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolidHeartIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.685 3.2c-2.974 0-5.479 1.918-6.685 3.034C14.793 5.118 12.289 3.2 9.314 3.2 5.06 3.2 1.6 6.776 1.6 11.173c0 2.754 2.432 5.26 2.53 5.36L16 28.8 27.863 16.54c.104-.107 2.537-2.612 2.537-5.366 0-4.397-3.46-7.973-7.715-7.973Z",
    fill: "#FFDCA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidHeartIco);
export default __webpack_public_path__ + "static/media/solid-heart_ico.64e06124d7cbef4444f9b14761c15ef3.svg";
export { ForwardRef as ReactComponent };